import type { ConfirmOptions } from '../context/ConfirmContext';

/**
 * The onboarding checklist no longer gates GEWONNEN. Whoever moves on with open
 * steps is asked once instead, and the steps can still be ticked afterwards.
 * Returns null when nothing is open — then there is nothing to ask.
 */
export function gewonnenRueckfrage(
  offen: number,
  gesamt: number,
  entitaet: 'bedarf' | 'bewerber',
): ConfirmOptions | null {
  if (offen === 0) return null;
  const schritte = entitaet === 'bedarf' ? 'Onboarding-Schritten' : 'Einstellen-Schritten';
  const verb = offen === 1 ? 'ist' : 'sind';
  return {
    title: entitaet === 'bedarf' ? 'Als gewonnen markieren?' : 'Als eingestellt markieren?',
    message: `${offen} von ${gesamt} ${schritte} ${verb} noch offen. Sie lassen sich danach in der Checkliste nachholen.`,
    confirmLabel: entitaet === 'bedarf' ? 'Trotzdem gewonnen' : 'Trotzdem einstellen',
    cancelLabel: 'Abbrechen',
    variant: 'warning',
  };
}
